import { Spin } from "antd";
import { LoaderStyled } from "./Loader.style";

interface Loader{
  className?: string
}

const Loader = (props: Loader) => {
  return (
    <LoaderStyled {...props}>
      <Spin />
    </LoaderStyled>
  );
};

export default Loader;
